const STORAGE_KEY = 'bf_context_search_session';

export function loadContextSearchSession(translation) {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.translation !== translation) return null;
    return {
      query: typeof data.query === 'string' ? data.query : '',
      results: Array.isArray(data.results) ? data.results : [],
      hasSearched: Boolean(data.hasSearched),
      error: typeof data.error === 'string' ? data.error : null,
      expandedBooks:
        data.expandedBooks && typeof data.expandedBooks === 'object' ? data.expandedBooks : {},
    };
  } catch {
    return null;
  }
}

export function saveContextSearchSession(translation, state) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        translation,
        query: state.query ?? '',
        results: Array.isArray(state.results) ? state.results : [],
        hasSearched: Boolean(state.hasSearched),
        error: state.error ?? null,
        expandedBooks: state.expandedBooks ?? {},
      })
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearContextSearchSession() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
